<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="EyeIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="ViewRecord" />
      <feather-icon v-if="!this.params.data.islocked && !readOnlyRole" icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" />
    </div>
</template>

<script>
import { isAccountantOnly } from '@/helpers/roleAccess.js'

export default {
  name: 'CellRendererActions',
  data () {
    // Comptable : consultation seulement (l'édition d'une dépense lui est fermée).
    return { readOnlyRole: isAccountantOnly() }
  },
  methods: {
    editRecord () {
        this.$router.push("/outlay-edit/" + this.params.data.id).catch(() => {})
    },
    ViewRecord () {
        this.$router.push("/outlay/" + this.params.data.id).catch(() => {})
    }
  }
}
</script>
